module.exports = __webpack_public_path__ + "static/paris-004-5344ff0566bc016fb4cc9e275e600aaa.jpg";